import buildIndicatorQueryKey from '@Application/Indicators/buildIndicatorQueryKey';
import type { IndicatorPeriod, IndicatorScope } from '@Application/Indicators/IndicatorScope';

type Args = {
	scope: IndicatorScope;
	period: IndicatorPeriod;
};

class FetchBeneficiaryIndicators {
	readonly scope: IndicatorScope;
	readonly period: IndicatorPeriod;
	readonly queryKey: string;

	constructor(args: Args) {
		this.scope = args.scope;
		this.period = args.period;
		this.queryKey = buildIndicatorQueryKey(args.scope, args.period);

		Object.freeze(this);
	}

	toQueryString(): string {
		return new URLSearchParams({ period: String(this.period) }).toString();
	}
}

export default FetchBeneficiaryIndicators;
